import CityPageTemplate from "../city-template/CityPageTemplate";
import { fairfieldConfig } from "./data";

export default function FairfieldPage() {
  return <CityPageTemplate config={fairfieldConfig} />;
}